export default __webpack_public_path__ + "static/media/CivilEng_IMG-Sungai.5ba9615a.png";